<mat-toolbar class="mat-primary">
  <span fxFlex>Preiskategorien hinzufügen</span>
  <mat-icon class="cursor-mat-element" (click)="close()">close</mat-icon>
</mat-toolbar>
<mat-dialog-content fxLayout="column" fxLayoutAlign=" none">
  <ng-container *ngIf="availableCategories.length === 0; else availableCategoryList">
    <section class="text-center">
      <h3>Keine weiteren Preiskategorien verfügbar</h3>
    </section>
  </ng-container>
  <ng-template #availableCategoryList>
    <ng-container *ngFor="let compensationCategory of availableCategories">
      <mat-checkbox
        [style]="{
          'padding': '1rem',
        }"
        [checked]="elementIsSelected(compensationCategory)"
        (click)="toggleSelectCompensationCategory(compensationCategory)">
        <section>
          <h4 class="mb-2">{{ compensationCategory.name }}</h4>
          Leistungsbereich:
          <b>{{ compensationCategory.powerRange | compCatPowerRangePipe }}</b>
          <br />
          Vergütung:
          <b>{{ compensationCategory.compensationAmount }} Ct/kWh</b>
          <br />
          Volleinspeisung:
          <b>{{ compensationCategory.isFullFeed ? 'Ja' : 'Nein' }}</b>
        </section>
      </mat-checkbox>
      <mat-divider></mat-divider>
    </ng-container>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions [style]="{ padding: '1rem' }">
  <button mat-button (click)="close()" color="primary" class="mr-3" mat-raised-button>Abbrechen</button>
  <button
    mat-button
    (click)="save()"
    [disabled]="selectedCategories.length === 0"
    color="primary"
    mat-raised-button>
    Hinzufügen
  </button>
</mat-dialog-actions>
